import React from 'react';
import styled from 'styled-components';
import Box from '../Box/Box.js';
import { get } from '../../constants.js';

/**
 *
 * GifWrapper renders a 16:9 aspect-ratio'd image container at 1010px, 768px, 454px, and 308px at different responsive breakpoints by default.
 *
 */
const GifWrapper = ({
  children,
  raised = true,
  hasBorder = true
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    as: "div",
    raised: raised
  }, /*#__PURE__*/React.createElement(ImgWrapper, {
    hasBorder: hasBorder
  }, children));
};
GifWrapper.displayName = "GifWrapper";
const Wrapper = styled(Box).withConfig({
  displayName: "GifWrapper__Wrapper",
  componentId: "sc-n3cppw-0"
})(["display:flex;max-width:min-content;border-radius:8px;position:relative;filter:", ";margin:0 auto;@media (min-width:", "){min-width:308px;min-height:174px;}@media (min-width:", "){min-width:454px;min-height:254px;}@media (min-width:", "){min-width:768px;min-height:432px;}@media (min-width:", "){min-width:", ";min-height:568px;}"], p => p.raised ? `drop-shadow(0px 18px 28px rgba(9, 30, 66, 0.15)) drop-shadow(0px 0px 1px rgba(9, 30, 66, 0.31))` : '', get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'), get('breakpoints.3'), p => p.width ? `${p.width}px` : '1010px');
const ImgWrapper = styled(Box).withConfig({
  displayName: "GifWrapper__ImgWrapper",
  componentId: "sc-n3cppw-1"
})(["display:flex;justify-content:center;border-radius:8px;border:", ";border-color:", ";position:relative;min-width:350px;img{width:100%;height:100%;display:block;object-fit:cover;aspect-ratio:16 / 9;border-radius:", ";}width:100%;@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}"], p => p.hasBorder ? '2px solid' : 'none', p => p.hasBorder ? get('colors.border.default') : 'transparent', p => p.hasBorder ? '6px' : 'revert', get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'), get('breakpoints.3'));
GifWrapper.displayName = 'GifWrapper';
var GifWrapper$1 = GifWrapper;

export { GifWrapper$1 as default };
